import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { DataTablePagination } from '@/types/_'
import { IntegradorFinx } from '@/types/core'

@Module({ namespaced: true, name: 'ConfigIntegradorFinxStore' })
export default class ConfigIntegradorFinxStore extends VuexModule {
  integradorFinxImp = new IntegradorFinx.IntegardorFinx()
  private paginationDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [10, 50, 100, 200],
  }

  public pagination: DataTablePagination = { ...this.paginationDefault }
  public integracoes: any[] = []
  public clientes: any[] = []
  public clienteId: any = {}

  @Mutation
  setClientes(itens: any[]) {
    this.clientes = itens
  }


  @Mutation
  setClienteId(id: any) {
    this.clienteId = id
  }

  @Mutation
  setIntegracoes(itens: any[]) {
    this.integracoes = itens
  }

  @Action
  async getAllClientes() {
    const response = await this.integradorFinxImp.getAllClientes()
    if (response.success) {
      const { commit } = this.context
      commit('setClientes', response.data)
    }
    return response
  }

  @Action
  async getIntegracoesByClienteKey(clienteKey: string) {
    const response = await this.integradorFinxImp.getIntegracoesByClienteKey(clienteKey)
    if (response.success) {
      const { commit } = this.context
      commit('setIntegracoes', response.data)
    }
    return response
  }
}
